import axios from "axios"

export class UserProfileService {
  static async getUserValuations(authToken) {
    return axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/user/valuations`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
    )
  }

  static async getUserProfile(authToken) {
    return axios.get(`${process.env.REACT_APP_API_BASE_URL}/user/profile`, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    })
  }

  static async updateUserProfile(authToken, profile) {
    const formData = new FormData()
    Object.keys(profile).forEach((key) => formData.append(key, profile[key]))
    return axios.put(
      `${process.env.REACT_APP_API_BASE_URL}/user/profile`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
        "Content-Type": "multipart/form-data",
      }
    )
  }
}
